export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.686 3.727l-2.988 2.82a15.98 15.98 0 013.078 2.923 1 1 0 01-.04 1.306l-10 10.9a1.002 1.002 0 01-1.474 0l-3.52-3.837-3.056 2.888-1.373-1.454 3.077-2.907-5.128-5.59a1.001 1.001 0 01-.039-1.306C4.157 5.858 8.053 4 12 4c2.033 0 4.051.494 5.932 1.465l3.381-3.192 1.373 1.454zM9.196 16.466L12 19.52l8.66-9.442a13.52 13.52 0 00-2.448-2.127l-9.015 8.515zM12 6c-3.058 0-6.161 1.332-8.662 4.078l4.507 4.914 8.53-8.055A10.816 10.816 0 0012 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};